import { NavigationUrls } from '../constants/NavigationUrls'
import accepted from '../assets/images/newui/navbar/confirmed-sales.svg'
import acceptedActive from '../assets/images/newui/navbar/confirmed-sales-active.svg'
import invoice from '../assets/images/newui/navbar/invoice.svg'
import invoiceActive from '../assets/images/newui/navbar/invoice-active.svg'
import pricingActive from '../assets/images/newui/navbar/pricing-active.svg'
import pricing from '../assets/images/newui/navbar/pricing.svg'
import openReqActive from '../assets/images/newui/navbar/open-request-hover.svg'
import openReq from '../assets/images/newui/navbar/open-request.svg'

import accepted_new from '../assets/images/newui/navbarNew/confirmed-sales.svg'
import acceptedActive_new from '../assets/images/newui/navbarNew/confirmed-sales-active.svg'
import invoice_new from '../assets/images/newui/navbarNew/invoice.svg'
import invoiceActive_new from '../assets/images/newui/navbarNew/invoice-active.svg'
import pricingActive_new from '../assets/images/newui/navbarNew/pricing-active.svg'
import pricing_new from '../assets/images/newui/navbarNew/pricing.svg'
import openReqActive_new from '../assets/images/newui/navbarNew/open-request-hover.svg'
import openReq_new from '../assets/images/newui/navbarNew/open-request.svg'


export default [
    {
        path: NavigationUrls.CUSTOMER_REQUESTS_LIST,
        name: "Dashboard",
        icon: 'list',
        showInSideBar: true
    },
    {
        path: NavigationUrls.CREATE_CUSTOMER_REQUEST,
        name: "Create Customer Request",
        icon: 'wpforms',
        showInSideBar: true
    },
    {
        path: NavigationUrls.SELLER_DRIVER,
        name: "My Drivers",
        icon: 'handshake',
        showInSideBar: true
    },
    {
        path: NavigationUrls.ACCEPTED_BIDS_URL,
        name: "Dashboard",
        icon: 'handshake',
        showInSideBar: false,
        img: accepted,
        activeImg: acceptedActive,
        imgNew: accepted_new,
        activeImgNew: acceptedActive_new
        
    },
    {
        path: NavigationUrls.INVOICE_SETTINGS,
        name: "My Pricing",
        icon: 'settings',
        showInSideBar: true,
        img: pricing,
        activeImg: pricingActive,
        imgNew: pricing_new,
        activeImgNew: pricingActive_new
    },
    {
        path: NavigationUrls.OPEN_REQUESTS,
        name: "Open Requests",
        icon: 'file text',
        showInSideBar: false,
        img: openReq,
        activeImg: openReqActive,
        imgNew: openReq_new,
        activeImgNew: openReqActive_new
        
    },
    {
        path: NavigationUrls.PROFILE_URL,
        name: "Profile",
        icon: 'user',
        showInSideBar: true
    },
    {
        path: NavigationUrls.SERVICES,
        name: "Services",
        icon: 'list',
        showInSideBar: true
    },
    {
        path: NavigationUrls.ACTIVE_SUBSCRIPTION,
        name: "Active Subscriptions",
        icon: 'bell',
        showInSideBar: true
    },
    {
        path: NavigationUrls.ADD_SUBSCRIPTION,
        name: "Add new Subscriptions",
        icon: 'bell',
        showInSideBar: true
    },
    {
        path: NavigationUrls.IN_ACTIVE_SUBSCRIPTION,
        name: "In Active Subscriptions",
        icon: 'bell',
        showInSideBar: true
    },
    {
        path: NavigationUrls.PENDING_COMMISSION_PAYMENTS,
        name: "Pending Commission Payments",
        icon: 'dollar sign',
        showInSideBar: true
    },
    {
        
        path: NavigationUrls.PAYMENT_METHOD,
        name: "Payment Methods",
        icon: 'payment',
        showInSideBar: true
    },
    {
        path: NavigationUrls.SERVICE_AREA,
        name: "Service Area",//"Preferences",
        icon: 'map marker alternate',
        showInSideBar: true
    },
    {
        path: NavigationUrls.PREFERENCES,
        name: "Preferences",
        icon: 'settings',
        showInSideBar: true
    },
    {
        path: NavigationUrls.INVOICES,
        name: "Payments",
        icon: 'book',
        showInSideBar: true,
        img: invoice,
        activeImg: invoiceActive,
        imgNew: invoice_new,
        activeImgNew: invoiceActive_new
        
    },
    {
        path: NavigationUrls.WORKING_SCHEDULES,
        name: "Business Hours",
        icon: 'calendar',
        showInSideBar: true
    }
];